var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injector, OnDestroy, OnInit } from '@angular/core';
import { RouteTable } from '../../core/route-table';
import { BaseCategoryListPage } from '../../core/base/base-category-list-page';
import { VariationDialog } from '../../dialogs/variation/variation';
import { VariationScrollDialog } from 'src/app/dialogs/variation-scroll/variation-scroll';
import { MultiStepComboPage } from 'src/app/routes/item/multi-step-combo/multi-step-combo-page.component';
import { getSetLayout } from '../../shared/utilities/layout-helper';
import { ComboPage } from 'src/app/routes/item/combo-page/combo-page';
import { ServiceChoiceComponent } from 'src/app/components/service-choice/service-choice.component';
import { ModifierItemSelectPageModal } from 'src/app/routes/item/modifier-item-select-modal/modifier-item-select-modal';
import { AddressDialog } from 'src/app/dialogs/address-dialog/address-dialog.component';
import { DeliveryLoginPage } from 'src/app/routes/member/delivery-login/delivery-login.page';
var CategoryListPage = /** @class */ (function (_super) {
    __extends(CategoryListPage, _super);
    function CategoryListPage(injector) {
        var _this = _super.call(this, injector) || this;
        _this.categories = [];
        _this.listMode = false;
        _this.isTreats = false;
        _this.fromBrandStoreList = false;
        _this.adShown = false;
        _this.login = false;
        _this.textCenter = false;
        _this.recommendationGroups = [];
        _this.allowToView = false;
        _this.sortBy = 'full';
        _this.normalCategories = [];
        _this.isImplementGostore = true;
        _this.requiredModifierMap = {};
        console.log('cat list construction');
        _this.fromBrandStoreList = _this.getNavParamsOrParams('fromBrandStoreList');
        _this.isTreats = _this.getNavParamsOrParams('isTreats');
        _this.storeClicked = _this.getNavParamsOrParams('storeClicked');
        _this.selectedValue = _this.store && "" + _this.store.id;
        _this.currentSelectedValue = _this.selectedValue;
        _this.stores = _this.getNavParamsOrParams('stores');
        _this.init();
        // this.orderManager.clear();
        var categoryList = _this.systemConfigService.menuLayout && _this.systemConfigService.menuLayout.categoryList || {};
        if (categoryList.itemTitle === 'center') {
            _this.textCenter = true;
        }
        if (_this.fromBrandStoreList) {
            _this.checkPopup(_this.store);
        }
        console.log('推荐信息', _this.settings, _this.settings.aiRecommendCount, _this.settings.aiRecommendCount);
        if (_this.settings.aiRecommendCount && _this.settings.aiRecommendCount > 0) {
            console.log('有推荐信息');
            _this.settingAiRecommendation();
        }
        else {
            _this.allowToView = true;
        }
        if (_this.mode === 'list') {
            if (document.getElementsByClassName('col-card') && document.getElementsByClassName('col-card').length) {
                _this.cateBoxHeight = document.getElementsByClassName('col-card')[0].clientWidth * 0.45;
            }
        }
        else {
            if (document.getElementsByClassName('col-card') && document.getElementsByClassName('col-card').length > 0) {
                _this.cateBoxHeight = document.getElementsByClassName('col-card')[0].clientWidth;
                // if (!this.cateBoxHeight) this.cateBoxHeight = 190;
                console.log('cateboxheight', _this.cateBoxHeight);
            }
        }
        return _this;
    }
    CategoryListPage.getPageUrl = function () {
        return 'category-list';
    };
    CategoryListPage.prototype.cartClicked = function () {
        if (!this.memberService.getMember() && this.orderManager.mode === 'delivery') {
            console.log('not login and isDelivery ###', this.orderManager.getOrder());
            if (this.orderManager.getOrder().orderitems.length > 0) {
                // save the current Order
                this.configService.putPreference(this.orderManager.store.id + '.savedOrder', this.orderManager.getOrder());
            }
            // popUp delivery-login within modal
            // this.popUpDeliveryLogin();
            // force to push delivery-login within route
            this.pushByName('DeliveryLoginPage', {
                store: this.store,
                fromPage: 'CategoryListPage',
                isRoute: true
            });
        }
        else {
            var page = getSetLayout(this.systemConfigService);
            if (page === 'ComboPage') {
                // new layout process
                if (this.orderService.isCourt ? this.multOrderManager.getOrders.length > 0 : this.orderManager.isEmpty()) {
                    var warning = this.t.instant('global.order-first');
                    var confirm_1 = this.t.instant('buttons.ok');
                    this.showAlert('', warning, [confirm_1]);
                }
                else {
                    this.pushByUrl((this.multOrderManager.enableMutlOrder ? RouteTable['MultiOrderCartPage'] : RouteTable['CartScrollPage']), { store: this.store });
                }
            }
            else {
                // origin process
                _super.prototype.cartClicked.call(this);
            }
        }
    };
    CategoryListPage.prototype.popUpDeliveryLogin = function () {
        return __awaiter(this, void 0, void 0, function () {
            var modal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalController.create({
                            component: DeliveryLoginPage,
                            componentProps: {
                                store: this.store,
                                isPopup: true
                            },
                            showBackdrop: true,
                            backdropDismiss: false,
                            cssClass: ''
                        })];
                    case 1:
                        modal = _a.sent();
                        modal.onDidDismiss().then(function (data) {
                        });
                        modal.present().then(function () {
                            //  cb()
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CategoryListPage.prototype.popUpService = function (ev) {
        var inputs = [];
        inputs = [{
                name: 'Bring Water',
                value: 'water',
                groupVal: null
            }, {
                name: 'Checkout',
                value: 'checkout',
                groupVal: null
            }, {
                name: 'Other Service',
                value: 'other',
                groupVal: null
            }];
        // for (const store_ of this.stores) {
        //     inputs.push({
        //         name: store_['name'],
        //         value: store_['id'],
        //         checked: this.store.id === store_['id'],
        //         store: store_
        //     });
        // }
        var params = {
            inputs: inputs
        };
        console.log('ly: -> category-list-page.ts -> popUpService() -> params:', params);
        this.showPopoverController(ServiceChoiceComponent, params, ev);
    };
    CategoryListPage.prototype.getNavParamsOrParams = function (key) {
        var obj;
        return this.getNavParams(key) ? this.getNavParams(key) : this.navigationService.getNavigationParams()[key];
    };
    CategoryListPage.prototype.goStore = function () {
        var _this = this;
        if (!this.isImplementGostore) {
            this.isImplementGostore = true;
            return;
        }
        var aimStore;
        this.stores.map(function (store) {
            if (store.id === Number(_this.selectedValue)) {
                aimStore = store;
            }
        });
        var enableMutlOrder = this.multOrderManager.enableMutlOrder;
        var isExsitOrder = enableMutlOrder ? this.multOrderManager.getOrderCount() > 0 : this.orderManager.count > 0;
        if (isExsitOrder && !enableMutlOrder) {
            var alert_1 = this.alertController.create({
                header: this.t.instant('pages.brand-store-list.alert-title'),
                backdropDismiss: false,
                buttons: [
                    {
                        text: this.t.instant('buttons.cancel'),
                        handler: function () {
                            _this.isImplementGostore = false;
                            _this.selectedValue = _this.currentSelectedValue;
                        }
                    },
                    {
                        text: this.t.instant('buttons.leave'),
                        handler: function () {
                            _this.orderManager.clear();
                            // this.navigationService.deactivateResult.next(true);
                            _this.navigationService.poping = true;
                            _this.currentSelectedValue = _this.selectedValue;
                            _this.navController.pop().then(function () { return _this.storeClicked(aimStore); });
                        }
                    }
                ]
            });
            alert_1.then(function (data) {
                console.log('alert created', data);
                data.present().then(function (success) {
                    console.log('success', success);
                }, function (reject) {
                    console.log('reject', reject);
                });
            });
        }
        else {
            this.navigationService.poping = true;
            this.currentSelectedValue = this.selectedValue;
            this.navController.pop().then(function () { return _this.storeClicked(aimStore); });
        }
    };
    CategoryListPage.prototype.getStore = function () {
        var _this = this;
        this.loading(true);
        this.menuService.getStore(this.storeId).subscribe(function (store) {
            _this.store = store;
            _this.setTheme(store.brand, store);
            // this.defaultImage = this.getDefaultImage(true, this.store.brand, 500);
            // this.defaultItemImage = this.getDefaultImage(false, this.store.brand, 500);
            _this.showStore(store);
        }, function (err) { return console.error(err); }, function () {
            _this.loading(false);
        });
    };
    CategoryListPage.prototype.categoryFilter = function (cats, types) {
        var result = [];
        var typeCat = {};
        var tmp = cats.filter(function (cat) {
            if (!cat.users || cat.users.length === 0) {
                return true;
            }
            else {
                var tmpSet = new Set(cat.users);
                for (var _i = 0, types_1 = types; _i < types_1.length; _i++) {
                    var type = types_1[_i];
                    console.log(type + ' cat name:', cat.name);
                    if (tmpSet.has(type)) {
                        if (!typeCat[type]) {
                            typeCat[type] = [];
                        }
                        typeCat[type].push(cat);
                        break;
                    }
                }
                return false;
            }
        });
        for (var type in typeCat) {
            result = result.concat(typeCat[type]);
        }
        this.normalCategories = [];
        this.normalCategories = this.normalCategories.concat(tmp);
        result = result.concat(tmp);
        return result;
    };
    CategoryListPage.prototype.showStore = function (store) {
        // var cats = store.menu.getAvailableCategories(store.brand);
        var now = this.convertNowDateToStoreTimeZone(store.timezone).getTime();
        var cats = this.menuManager.getAvailableCategories(store, now, this.orderManager.mode === 'takeaway');
        if (!cats)
            return;
        if (!cats[0] || !cats[0].id) {
            return;
        }
        this.marker = this.getNavParamsOrParams('marker');
        var member = this.memberService.getMember();
        if (member) {
            this.userTypes.push('member');
            this.orderManager.setUserPoints(member);
        }
        if (this.marker && this.marker.length > 0) {
            for (var _i = 0, _a = this.marker; _i < _a.length; _i++) {
                var marker = _a[_i];
                this.userTypes.push(marker);
            }
        }
        cats = this.categoryFilter(cats, this.userTypes);
        this.menu = store.menu;
        this.defaultImage = this.getDefaultImage(true, this.store.brand, 500);
        this.defaultItemImage = this.getDefaultImage(false, this.store.brand, 500);
        var imgCount = 0;
        if (store.menu.settings['catLayout']) {
            this.mode = store.menu.settings.catLayout === 'topMenu' ?
                'grid' : store.menu.settings.catLayout;
        }
        else {
            // Set Default Layout
            this.mode = 'grid';
        }
        this.imgs = [];
        for (var _b = 0, cats_1 = cats; _b < cats_1.length; _b++) {
            var cat = cats_1[_b];
            var img = void 0;
            if (this.mode === 'list') {
                img = cat.getImage('default', 500, false);
            }
            else {
                img = cat.getImage('default', 360, true);
            }
            if (img) {
                this.imgs.push(img);
            }
            else {
                this.imgs.push(this.defaultImage);
            }
        }
        this.categories = cats;
        this.orderManager.store = store;
    };
    CategoryListPage.prototype.showEmpty = function (index) {
        this.imgs[index] = this.defaultImage;
    };
    CategoryListPage.prototype.ngOnInit = function () {
        console.log('####', this.orderManager.mode);
    };
    CategoryListPage.prototype.init = function () {
        console.log('cat list will enter');
        if (!this.store && this.storeId) {
            this.getStore();
        }
        else if (this.store) {
            this.showStore(this.store);
        }
        if (this.memberService.member && this.orderManager.mode === 'delivery') {
            console.log('login ### member', this.memberService.member);
            this.getAddress();
        }
    };
    CategoryListPage.prototype.getAddress = function () {
        var _this = this;
        this.addressManagerService.getAddresses(this.orderService.store).subscribe(function (addressArr) {
            console.log('catlistPage getAddresses #######', addressArr);
            var addressArrBeyond = addressArr.filter(function (address) { return !address['beyond']; });
            if (addressArrBeyond.length >= 1) {
                _this.addressManagerService.findDefaultAddress().then(function (defautlAddress) {
                    _this.addressManagerService.saveCurrentAddress(defautlAddress);
                    _this.addressManagerService.calculateAddress(defautlAddress, _this.orderService.store).subscribe(function (result) {
                        _this.loading(false);
                    }, function (err) {
                        _this.loading(false);
                        return _this.showAlert(err.status, err['error']);
                    });
                });
            }
            else {
                console.log('Did not save the address message');
            }
        });
    };
    CategoryListPage.prototype.popUpAddressModal = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var modal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalController.create({
                            component: AddressDialog,
                            componentProps: params,
                            showBackdrop: true,
                            backdropDismiss: false,
                            cssClass: ''
                        })];
                    case 1:
                        modal = _a.sent();
                        modal.onDidDismiss().then(function (data) {
                        });
                        modal.present().then(function () {
                            //  cb()
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CategoryListPage.prototype.ionViewDidEnter = function () {
        // if (this.mode === 'list') {
        //     if (document.getElementsByClassName('col-card') && document.getElementsByClassName('col-card').length) {
        //         this.cateBoxHeight = document.getElementsByClassName('col-card')[0].clientWidth * 0.45;
        //     }
        // } else {
        //     if (document.getElementsByClassName('col-card') && document.getElementsByClassName('col-card').length > 0) {
        //         this.cateBoxHeight = document.getElementsByClassName('col-card')[0].clientWidth;
        //         //if (!this.cateBoxHeight) this.cateBoxHeight = 190;
        //         console.log('cateboxheight', this.cateBoxHeight);
        //     }
        // }
    };
    CategoryListPage.prototype.ngOnDestroy = function () {
        if (!this.multOrderManager.enableMutlOrder && !this.orderService.isHomeButton) {
            this.orderManager.clear();
            var onlyMode = this.systemConfigService.OnlyModeInBrandStoreListPage;
            if (onlyMode) {
                this.onlyModeHandle(onlyMode);
            }
        }
    };
    CategoryListPage.prototype.checkPopup = function (store) {
        return __awaiter(this, void 0, void 0, function () {
            var popupLocation;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('TCL: checkPopup -> store', store);
                        popupLocation = 'welcome';
                        return [4 /*yield*/, this.layoutService.showPopup(store, popupLocation, function (data) {
                                console.log('ad data', data);
                                if (data && data.data) {
                                    var actionString = data.data.url;
                                    actionString = actionString.split('//')[1];
                                    // if (actionString === 'registration') {
                                    //     let page = this.memberService.getMember() ? MemberRewardPage : VerifyRegistrationPage;
                                    //     this.navController.push(page, {
                                    //         store: this.store,
                                    //         member: this.memberService.getMember(),
                                    //         fromPage: ByodSplashPage, logincb: () => {
                                    //             // this.next();
                                    //         }
                                    //     });
                                    // } else if (actionString === 'login' || actionString === 'loginbridge') {
                                    //     let page = null;
                                    //     if (actionString === 'login') {
                                    //         page = LoginPage;
                                    //     } else if (actionString === 'loginbridge') {
                                    //         page = LoginBridgePage;
                                    //     }
                                    //     // if(this.memberService.getMember())
                                    //     // {
                                    //     //     page = MemberRewardPage;
                                    //     // }
                                    //     if (page) {
                                    //         this.navController.push(page, {
                                    //             store: this.store,
                                    //             fromPage: ByodSplashPage, logincb: () => {
                                    //                 // this.next();
                                    //             }
                                    //         });
                                    //     }
                                    // }
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CategoryListPage.prototype.pageName = function () {
        return '/category-list';
    };
    CategoryListPage.prototype.itemClicked = function (category, index) {
        var _this = this;
        console.log('cat clicked');
        // need a flag
        var layout = category.layout ? category.layout : this.store.menu.settings.itemLayout;
        if (!layout) {
            // this.push(CategoryItemListPage, { store: this.store, storeId: this.store.id, categoryIndex: index });
            layout = 'grid';
        }
        // when merge renew ,perfecting logic
        var page = 'ItemGridPage';
        if (!this.getIsForceOldLayout()) {
            page = 'ItemGridScrollPage';
        }
        var warning = (category && category['warning']) || null;
        if (warning /* && StaticService.canShowWarning*/) {
            var buttons = [
                {
                    text: this.t.instant('buttons.cancel'),
                    handler: function (value) {
                    }
                },
                {
                    text: this.t.instant('buttons.ok'),
                    handler: function (value) {
                        _this.pushByUrl(RouteTable[page], {
                            store: _this.store,
                            category: category,
                            categories: _this.categories,
                            layout: layout,
                            stores: _this.stores,
                            storeClicked: function (store) { return _this.storeClicked(store); },
                        }, { relativeTo: _this.route });
                        /*
                                                StaticService.warningShowTime++;
                        */
                    }
                }
            ];
            this.showAlertControlBDDismiss(null, warning, buttons, false);
        }
        else {
            this.pushByUrl(RouteTable[page], {
                store: this.store,
                category: category,
                categories: this.categories,
                layout: layout,
                stores: this.stores,
                storeClicked: function (store) { return _this.storeClicked(store); },
            }, { relativeTo: this.route });
        }
        if (this.orderService.isCourt) {
            this.gaService.eventTrack('main-listing-page', 'select category - ' + this.store.name, category.name);
        }
    };
    CategoryListPage.prototype.showAlertControlBDDismiss = function (title, message, buttons, enableBackdropDismiss) {
        if (buttons === void 0) { buttons = ['OK']; }
        if (enableBackdropDismiss === void 0) { enableBackdropDismiss = true; }
        return __awaiter(this, void 0, void 0, function () {
            var alert;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!buttons) {
                            buttons = ['OK'];
                        }
                        return [4 /*yield*/, this.alertController.create({
                                header: title,
                                subHeader: message,
                                buttons: buttons,
                                backdropDismiss: enableBackdropDismiss
                            })];
                    case 1:
                        alert = _a.sent();
                        alert.present();
                        return [2 /*return*/, alert];
                }
            });
        });
    };
    CategoryListPage.prototype.backButtonClick = function () {
        // no need alert msg
        console.log('backButtonClick');
        if (this.navigationService.poping || this.navigationService.navigating) {
            return;
        }
        if (this.multOrderManager.enableMutlOrder) {
            this.navigationService.poping = true;
            this.navController.pop(); // can clear history
        }
        // else if (!this.multOrderManager.enableMutlOrder && this.orderManager.getOrder().orderitems.length === 0) {
        //     super.backButtonClick();
        // }
        else {
            _super.prototype.backButtonClick.call(this);
        }
    };
    // tapSearch  end
    // tapSearch  start
    CategoryListPage.prototype.tapSearch = function () {
        this.pushByName('SearchItemPage', { categories: this.categories, store: this.store, storeId: this.storeId });
    };
    //
    CategoryListPage.prototype.getRecommendation = function (member) {
        var _this = this;
        this.loading(true);
        this.aiService.getRecommend(member).subscribe(function (behavior) {
            _this.allowToView = true;
            _this.loading(false);
            console.log('behavior', behavior);
            _this.behavior = behavior.food;
            _this.recommendations = _this.recommendationManager.makeRecommendations(_this.store.menu, _this.memberService.member, behavior.food, 'single', 200);
            _this.hasRecommendation = _this.recommendations && _this.recommendations.length > 0;
            console.log('ai recommendation', _this.recommendations);
            _this.recommendationGroups = _this.recommendationManager.groupRecommendations(_this.recommendations, _this.sortBy);
            // filtering
            _this.recommendationGroups = _this.recommendationGroups.filter(function (recomG) {
                var order = _this.orderManager.getOrder();
                for (var _i = 0, _a = order.orderitems; _i < _a.length; _i++) {
                    var oi = _a[_i];
                    // only check for a le carte item
                    if (oi.items && oi.items.length === 1) {
                        // if (oi.items[0].id === recom.item.id) {
                        //     console.log("same item now remove", recom.item.name);
                        //     return false;
                        // }
                        for (var _b = 0, _c = recomG.recommendations; _b < _c.length; _b++) {
                            var recom = _c[_b];
                            if (oi.items[0].id === recom.item.id) {
                                console.log('same item now remove', recom.item.name);
                                return false;
                            }
                        }
                    }
                }
                return true;
            });
            _this.recommendationGroups = _this.recommendationGroups.slice(0, _this.settings.aiRecommendCount);
            console.log('recommendationGroups', _this.recommendationGroups);
            // if(this.memberService.getMember())
            // {
            //     this.recommendations.sort((a,b) => (a["reasons"][0]["score"] < b["reasons"][0]["score"]) ? 1 : ((b["reasons"][0]["score"] < a["reasons"][0]["score"]) ? -1 : 0));
            //     //this.recommendations.sort((a,b) => (a["reasons"][2]["value"] < b["reasons"][2]["value"]) ? 1 : ((b["reasons"][2]["value"] < a["reasons"][2]["value"]) ? -1 : 0));
            //     //this.recommendations.reverse();
            // }else
            // {
            //     this.recommendations.sort((a,b) => (a["reasons"][2]["value"] < b["reasons"][2]["value"]) ? 1 : ((b["reasons"][2]["value"] < a["reasons"][2]["value"]) ? -1 : 0));
            // }
        }, function (err) {
            _this.allowToView = true;
            _this.loading(false);
            _this.showError(err);
        });
    };
    CategoryListPage.prototype.checkStoreMaxItem = function () {
        var maxItems = this.orderManager.store.menu.maxItems;
        var infinity = maxItems === 0;
        return (maxItems <= this.orderManager.count && !infinity);
    };
    CategoryListPage.prototype.isRequiredModifier = function (item) {
        if (this.isModifiable(item)) {
            if (!this.requiredModifierMap[item.id]) {
                this.requiredModifierMap[item.id] = item.mgroups.some(function (mgroup) { return mgroup.min > 0; });
            }
            return this.requiredModifierMap[item.id];
        }
        else {
            return false;
        }
    };
    CategoryListPage.prototype.recommendationGroupclicked = function (recomGroup) {
        return __awaiter(this, void 0, void 0, function () {
            var canGoFilter, items, category, _i, _a, recom, group, input, component, modalDismissToPage_1, girdLayout, cssClass, modal;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        canGoFilter = false;
                        console.log('recom group', recomGroup);
                        items = [];
                        category = recomGroup.recommendations[0].category;
                        for (_i = 0, _a = recomGroup.recommendations; _i < _a.length; _i++) {
                            recom = _a[_i];
                            items.push(recom.item);
                            if (this.isParent(recom.item)) {
                                group = recomGroup.recommendations[0].category.groups[0];
                                // if ((group.filters2 && group.filters2.length > 0) || (group.filters && group.filters.length > 0)) {
                                //     canGoFilter = true;
                                //     this.presentItemFilter(recom.item, group, (data) => {
                                //         console.log("presentItemFilter result", data);
                                //         //this.addItem(data);
                                //         if (this.isSetItem(data, recomGroup.recommendations[0].category) || data.pgroup) {
                                //             var page = this.settings.setLayout === "multi-steps" ? MultiStepComboPage : (this.settings.setLayout === "multi-page" ? PopUpSetMenuPage : SetSubItemsPage);
                                //             this.navController.push(page, {
                                //                 store: this.store,
                                //                 category: recomGroup.recommendations[0].category,
                                //                 groups: recomGroup.recommendations[0].category.groups,
                                //                 item: data
                                //             });
                                //         } else {
                                //             this.addItem(data, recomGroup.recommendations[0].category, recomGroup.recommendations[0].category.groups);
                                //             this.showToast(this.t.instant("global.item-added"))
                                //         }
                                //     })
                                // }
                            }
                        }
                        if (!!canGoFilter) return [3 /*break*/, 2];
                        input = { items: items, store: this.store, category: category, orderManager: this.orderManager };
                        component = void 0;
                        girdLayout = getSetLayout(this.store.menu.setLayout);
                        cssClass = 'modal-largescreen';
                        if (girdLayout === 'ComboPage') {
                            component = VariationScrollDialog;
                            modalDismissToPage_1 = ComboPage;
                            cssClass = cssClass + ' combo-modal-backdrop-dismiss';
                        }
                        else {
                            component = VariationDialog;
                            modalDismissToPage_1 = MultiStepComboPage;
                        }
                        return [4 /*yield*/, this.modalController.create({
                                component: component,
                                componentProps: input,
                                showBackdrop: true,
                                backdropDismiss: true,
                                cssClass: cssClass
                            })];
                    case 1:
                        modal = _b.sent();
                        modal.onWillDismiss().then(function (data) { return __awaiter(_this, void 0, void 0, function () {
                            var selected, bool, page, params, oi, params, m;
                            var _this = this;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        selected = (data['data']);
                                        if (!selected) return [3 /*break*/, 3];
                                        console.log('select & add item');
                                        if (this.checkStoreMaxItem()) {
                                            this.showStoreMaxItemAlert();
                                            return [2 /*return*/];
                                        }
                                        bool = this.isSetItem(selected, category);
                                        if (!(bool || selected.pgroup)) return [3 /*break*/, 1];
                                        page = getSetLayout(this.orderManager.store.menu.setLayout);
                                        params = {
                                            store: this.store,
                                            category: category,
                                            groups: category.groups,
                                            item: selected
                                        };
                                        console.log('set layout', page);
                                        this.navToAssignLayoutItems(modalDismissToPage_1, page, params, {
                                            relativeTo: this.route,
                                            skipLocationChange: false
                                        });
                                        return [3 /*break*/, 3];
                                    case 1:
                                        oi = this.addItem(selected, category, category.groups[0]);
                                        if (!(this.isRequiredModifier(selected) || (this.isModifiable(selected) && !this.store.menu.quickSingleItem))) return [3 /*break*/, 3];
                                        params = { store: this.store, orderitem: oi, edit: true };
                                        return [4 /*yield*/, this.modalController.create({ component: ModifierItemSelectPageModal, componentProps: params })];
                                    case 2:
                                        m = _a.sent();
                                        m.onDidDismiss().then(function (data) {
                                            console.log('ModifierItemSelectPageModal res', data);
                                            if (data['data'] === 'confirm') {
                                                // do....
                                                // this.showToast(this.t.instant('global.item-added'));
                                            }
                                            else {
                                                _this.removeClicked(selected);
                                            }
                                        });
                                        m.present();
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); });
                        modal.present();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    CategoryListPage.prototype.addItem = function (item, cat, group) {
        // this.orderService.addSingleItem(this.category, this.groups[0], item);
        var oi = this.orderManager.addSingleItem(cat, group, item, false);
        this.orderManager.getQuantity(item);
        return oi;
    };
    CategoryListPage.prototype.settingAiRecommendation = function () {
        var member = this.memberService.getMember();
        if (!member) {
            this.getRecommendation({});
        }
        else {
            this.getRecommendation(member);
        }
    };
    CategoryListPage.prototype.recomItemclicked = function (item, recom) {
        var _this = this;
        console.log('recomItemclicked', item, recom);
        if (this.inventoryManager.isSoldout(item)) {
            return;
        }
        if (item.groupIds.length > 0) {
            var page = getSetLayout(this.store.menu.setLayout);
            // old logic when page ='MultiStepComboPage' is pop up modal
            // new logic when page = 'MultiStepComboPage' is pop up old modal and  page='ComboPage' is pop up renew-layout-modal
            var component = void 0;
            var cssClass = '';
            if (page === 'ComboPage') {
                component = ComboPage;
                cssClass = 'modal-largescreen set-list-view combo-modal-backdrop-dismiss';
            }
            else {
                component = MultiStepComboPage;
            }
            var groups_1 = [];
            item.groupIds.forEach(function (groupId) {
                groups_1.push(_this.store.menu['gmap'][groupId]);
            });
            item.groups = groups_1;
            var params = {
                // this.pushByUrl(RouteTable[page], {
                store: this.store,
                category: recom.category,
                groups: [recom.itemgroup],
                item: item
                // }, {relativeTo: this.route});
            };
            this.navToAssignLayoutItems(component, page, params, {
                relativeTo: this.route
            }, cssClass);
        }
        else {
            this.orderManager.addSingleItem(recom.category, recom.itemgroup, item, false);
            // this.applyPromotion();
        }
    };
    CategoryListPage.prototype.recommedImage = function (recomGroup) {
        var b = null;
        var a = recomGroup.recommendations[0].item;
        if (a && a.getImage('default', 360, true)) {
            b = a.getImage('default', 360, true);
        }
        //    let c = Item.getImage(a,'default',360,true);
        return b;
    };
    CategoryListPage.prototype.isSet = function (recom) {
        return this.isSetItem(recom.item, recom.category);
    };
    CategoryListPage.prototype.removeClicked = function (item) {
        console.log('remove clicked');
        // this.orderService.deleteItem(item);
        // this.orderService.minusItem(item);
        this.orderManager.minusItem(item, true);
    };
    CategoryListPage.prototype.getIsForceOldLayout = function () {
        // return true;
        return this.systemConfigService['systemConfig'] && this.systemConfigService['systemConfig']['data'] && this.systemConfigService['systemConfig']['data']['forceOldLayout'];
    };
    return CategoryListPage;
}(BaseCategoryListPage));
export { CategoryListPage };
